import { render, staticRenderFns } from "./AttachmentListSkeleton.vue?vue&type=template&id=5a0ff88e&lang=pug"
import script from "./AttachmentListSkeleton.vue?vue&type=script&lang=ts"
export * from "./AttachmentListSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports